import { render, staticRenderFns } from "./VselectDouble.vue?vue&type=template&id=e16d6d5e"
import script from "./VselectDouble.vue?vue&type=script&lang=js"
export * from "./VselectDouble.vue?vue&type=script&lang=js"
import style0 from "./VselectDouble.vue?vue&type=style&index=0&id=e16d6d5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports